export default __webpack_public_path__ + "static/media/truck-wrap-1.3cb90b02.jpeg";